<template>
    <div>
        <card>
            <template slot="header">
                Templates
            </template>
            <div class="row">
                <div class="col-12 d-flex justify-content-end">
                    <div v-if="
                        user.admin ||
                        (event.adminRoles &&
                            event.adminRoles[user._id] &&
                            event.adminRoles[user._id]
                                .editTemplates)
                    ">
                        <el-button @click="templateFormOpen = true" type="primary" class="btn btn-primary">
                            New
                        </el-button>
                    </div>
                </div>
            </div>
            <el-table :data="templates">
                <el-table-column label="Name" prop="name" min-width="200px">
                </el-table-column>
                <el-table-column label="Actions" min-width="300px">
                    <template slot-scope="props">
                        <el-tooltip content="Print" placement="top">
                            <el-button @click="fetchPrintables(props.row)" class="btn btn-primary mr-1" title="print">
                                <fa :icon="['fas', 'print']" />
                            </el-button>
                        </el-tooltip>
                        <el-tooltip :content="pdfUrl(props.row._id) ? 'Open PDF' : 'Generate PDF'" placement="top">
                            <el-button @click="handlePdf(props.row)" :loading="isGenerating(props.row._id)"
                                class="btn btn-warning mr-1"
                                :title="pdfUrl(props.row._id) ? 'Open PDF' : 'Generate PDF'">
                                <fa :icon="['fas', pdfUrl(props.row._id) ? 'download' : 'file-pdf']" />
                            </el-button>
                        </el-tooltip>
                        <template v-if="
                            user.admin ||
                            (event.adminRoles &&
                                event.adminRoles[user._id] &&
                                event.adminRoles[user._id]
                                    .editTemplates)
                        ">
                            <el-tooltip content="Edit" placement="top">
                                <el-button @click="edit(props.row._id)" class="btn" title="Edit">
                                    <fa :icon="['fas', 'pen']" />
                                </el-button>
                            </el-tooltip>
                        </template>
                        <el-tooltip v-if="
                            user.admin ||
                            (event.adminRoles &&
                                event.adminRoles[user._id] &&
                                event.adminRoles[user._id]
                                    .editTemplates)
                        " content="Delete" placement="top">
                            <el-button @click="remove(props.row._id)" class="btn btn-danger ml-1" title="Delete">
                                <fa :icon="['fas', 'trash']" />
                            </el-button>
                        </el-tooltip>
                    </template>
                </el-table-column>
            </el-table>
        </card>

        <el-dialog width="70%" v-if="templateFormOpen" :visible.sync="templateFormOpen" :close-on-click-modal="false">
            <TemplateForm :fieldsForFilter="fieldsForFilter" :templateId="templateId"
                @close="templateFormOpen = false" />
        </el-dialog>
        <el-dialog width="70%" v-if="printModalOpen" :visible.sync="printModalOpen" :close-on-click-modal="false">
            <div v-if="loading" class="d-flex justify-content-center">
                <i class="fa fa-spinner fa-spin fa-3x fa-fw"></i>
            </div>

            <div v-else>
                <el-table :data="Object.values(allRegistrants)" style="max-height:50vh; overflow: auto;"
                    @selection-change="toggleExludeList">
                    <el-table-column type="selection" label="Select" align="center" width="100%" />
                    <el-table-column label="Confirmation" prop="confirmationNumber">
                        <template slot-scope="props">
                            <router-link target="_blank" :to="`/dashboard/${eventId}/attendees/${props.row._id
                                }?tab=general_information`
                                ">{{ props.row.confirmationNumber }}</router-link>
                        </template>
                    </el-table-column>
                    <!-- <el-table-column label="Select" width="100%" align="center">
                        <template slot-scope="props">
                            <el-checkbox
                                :checked="true"
                                @change="
                                    val => toggleExludeList(props.row, val)
                                "
                            />
                        </template>
                    </el-table-column> -->
                    <el-table-column label="Name" prop="name" />
                    <el-table-column label="Email" prop="email" />
                    <el-table-column label="Total" prop="total" />
                    <el-table-column label="Paid" prop="paid" />
                    <el-table-column label="Due" prop="due" />
                    <el-table-column label="Type" prop="type.name" />
                    <el-table-column label="Preview">
                        <template slot-scope="props">
                            <button class="btn btn-primary" @click="openPreviewDialog(props.row)">
                                preview
                            </button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <template slot="footer">
                <div class="d-flex" style="align-items: center; justify-content: space-between;">
                    <div>
                        <p v-if="dialogPdfGenerating" class="p-0 m-0 text-muted">PDF generation may take a while, check back in a few minutes.</p>
                    </div>
                    <el-button v-if="!loading" type="primary" :loading="dialogPdfGenerating"
                        @click="generateDialogPdf">
                        Generate PDF
                    </el-button>
                </div>
            </template>
        </el-dialog>
        <el-dialog v-if="previewDialog" :visible.sync="previewDialog" :close-on-click-modal="false">
            <div v-if="previewLoading" class="d-flex justify-content-center">
                <i class="fa fa-spinner fa-spin fa-3x fa-fw"></i>
            </div>
            <div v-else v-html="html" class="ql-editor"></div>
        </el-dialog>

    </div>
</template>

<script>
import { mapState } from "vuex";
import swal from "sweetalert2";
import http from "../../http";
import TemplateForm from "./TemplateForm.vue";

export default {
    data() {
        return {
            templateFormOpen: false,
            templateId: null,
            printModalOpen: false,
            selectedRegistrants: [],
            allRegistrants: [],
            html: "",
            previewDialog: false,
            eventId: null,
            selectedTemplateForPrint: {},
            loading: false,
            previewLoading: false,
            fieldsForFilter: [],
            // PDF state, keyed by template id. A template can have at most one
            // generated PDF at a time, mirroring the standalone reports.
            //
            // The result and the in-flight flag are kept apart on purpose: a
            // template can have a finished PDF on disk while a newer one is
            // being generated, and the button needs to show the spinner for the
            // latter without losing the former.
            pdfs: {},
            pdfGenerating: {},
            pdfPollers: {}
        };
    },
    components: { TemplateForm },
    computed: {
        ...mapState(["user", "event", "templates"]),
        // A computed rather than a method: the template binds this as a value
        // (`:loading="dialogPdfGenerating"`), and a method reference is always
        // truthy, which left the button spinning permanently.
        dialogPdfGenerating() {
            return this.isGenerating(this.selectedTemplateForPrint._id);
        }
    },
    watch: {
        templateFormOpen(nv) {
            if (!nv) this.templateId = null;
        }
    },
    methods: {
        async remove(id) {
            let { value: confirmed } = await swal({
                title: `Are you sure you want to delete the template?`,
                buttonsStyling: false,
                showCancelButton: true,
                confirmButtonText: "OK",
                cancelButtonText: "Cancel",
                confirmButtonClass: "btn btn-success btn-fill",
                cancelButtonClass: "btn btn-default btn-fill"
            });
            if (!confirmed) {
                return;
            }

            try {
                const res = await http.delete(`/api/templates/${id}`);
                if (res.data.message) {
                    this.$notify(res.data.message);
                }
                await this.$store.dispatch("getAll", { path: "templates", query: `event=${this.eventId}` });
            } catch (error) {
                console.log(error);
                if (error.response.data.message) {
                    this.$notify(error.response.data.message);
                }
            }
        },
        edit(id) {
            this.templateId = id;
            this.templateFormOpen = true;
        },
        async fetchPrintables(data) {
            this.selectedTemplateForPrint = data;
            this.printModalOpen = true;
            this.loading = true;
            try {
                const res = await http.post("/api/templates/registrants", { templateId: data._id });
                this.allRegistrants = res.data.registrations;
                this.selectedRegistrants = this.allRegistrants;
                setTimeout(() => {
                    document.querySelector('th.el-table-column--selection .el-checkbox input').click()
                }, 500)
            } catch (error) {
                this.$store.dispatch('handleErrors', error);
            }
            this.loading = false;
        },
        // The template is rendered server-side: the recipient rows no longer
        // carry the full event and type documents the template needs, and the
        // rendering logic is shared with the PDF job.
        async openPreviewDialog(registration) {
            this.previewDialog = true;
            this.previewLoading = true;
            try {
                const res = await http.post("/api/templates/preview", {
                    templateId: this.selectedTemplateForPrint._id,
                    registrationId: registration._id
                });
                this.html = res.data.html;
            } catch (error) {
                this.$store.dispatch("handleErrors", error);
                this.previewDialog = false;
            }
            this.previewLoading = false;
        },
        async toggleExludeList(registrations) {
            this.selectedRegistrants = registrations
        },

        // --- PDF generation -------------------------------------------------

        pdfUrl(templateId) {
            const pdf = this.pdfs[templateId];
            return pdf && pdf.url ? pdf.url : null;
        },
        isGenerating(templateId) {
            return !!this.pdfGenerating[templateId];
        },
        // One click: open the PDF if one exists, otherwise start generating it.
        handlePdf(template) {
            const url = this.pdfUrl(template._id);
            if (url) {
                window.open(url, "_blank");
                return;
            }
            this.generatePdf(template);
        },
        // Renders the whole template. The dialog's Generate button passes the
        // ticked registrants instead, so only those are rendered.
        //
        // `openWhenReady` is set by the dialog: the user asked for a PDF of a
        // specific selection, so it is opened as soon as the job finishes
        // rather than making them click again.
        async generatePdf(template, registrationIds, openWhenReady = false) {
            this.$set(this.pdfGenerating, template._id, true);
            try {
                await http.post("/api/templates/generate-pdf", {
                    templateId: template._id,
                    ...(registrationIds && registrationIds.length && { registrationIds })
                });
                this.pollForPdf(template._id, openWhenReady);
            } catch (error) {
                if (error.response && error.response.status === 409) {
                    // A job is already running, so just watch it.
                    this.pollForPdf(template._id, openWhenReady);
                } else {
                    this.$store.dispatch("handleErrors", error);
                    this.$set(this.pdfGenerating, template._id, false);
                }
            }
        },

        // --- PDF for the current dialog selection ---------------------------

        async generateDialogPdf() {
            const ids = this.selectedRegistrants.map(reg => reg._id);
            if (!ids.length) {
                this.$notify({ type: "warning", message: "Select at least one registrant." });
                return;
            }
            await this.generatePdf(this.selectedTemplateForPrint, ids, true);
        },
        pollForPdf(templateId, openWhenReady = false) {
            if (this.pdfPollers[templateId]) {
                clearInterval(this.pdfPollers[templateId]);
            }
            this.pdfPollers[templateId] = setInterval(async () => {
                await this.refreshPdf(templateId, openWhenReady);
            }, 2000);
        },
        async refreshPdf(templateId, openWhenReady = false) {
            try {
                const res = await http.get("/api/templates/latest-pdf", {
                    params: { templateId }
                });

                if (res.data.status === "completed") {
                    this.$set(this.pdfs, templateId, {
                        url: res.data.pdfUrl,
                        date: res.data.reportDate
                    });
                    this.$set(this.pdfGenerating, templateId, false);
                    this.stopPolling(templateId);

                    if (openWhenReady) {
                        window.open(res.data.pdfUrl, "_blank");
                    }
                } else if (res.data.status === "pending" || res.data.status === "processing") {
                    this.$set(this.pdfGenerating, templateId, true);
                } else {
                    // Nothing queued and nothing generated: the job failed, or
                    // there never was one. Either way stop waiting, otherwise
                    // the spinner would never clear.
                    this.$set(this.pdfGenerating, templateId, false);
                    this.stopPolling(templateId);
                }
            } catch (error) {
                this.$store.dispatch("handleErrors", error);
            }
        },
        stopPolling(templateId) {
            if (this.pdfPollers[templateId]) {
                clearInterval(this.pdfPollers[templateId]);
                delete this.pdfPollers[templateId];
            }
        }
    },
    async mounted() {
        this.eventId = this.$route.params.eventId;
        await this.$store.dispatch("getAll", { path: "templates", query: `event=${this.eventId}` });
        this.fieldsForFilter = (await http.get(`/api/fields-for-filters/${this.$route.params.eventId}`)).data.fields;
        // Pick up any PDF generated in an earlier session.
        this.templates.forEach(template => this.refreshPdf(template._id));
    },
    beforeDestroy() {
        Object.values(this.pdfPollers).forEach(clearInterval);
    }
};
</script>
